import {ReferralRepository} from '@raf/core/domain/ReferralRepository';

type GetReferralForShareType = (repository: ReferralRepository) => ReferralRepository['getReferralForShare'];

const GetReferralForShare: GetReferralForShareType = repository => () => {
  return repository.getReferralForShare();
};

export {GetReferralForShare};
